"use strict";

var _core = require("../core");

var _logger = require("./logger");

(0, _core.setLogger)(_logger.logger);